import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { InputBlocker } from "./InputBlocker";

export class FullScreenInputBlocker extends InputBlocker {
    private canvasScaler: ICanvasScaler;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.canvasScaler = canvasScaler;
        this.layout();
    }

    private layout(): void {
        this.width = this.canvasScaler.bounds.width;
        this.height = this.canvasScaler.bounds.height;
        this.position.x = this.canvasScaler.referenceWidth * 0.5 - this.width * 0.5;
    }
}